import { navigate } from "gatsby";
import { toast } from "react-hot-toast";
import {
  client,
  clearAuthTokens as clearApolloAuthTokens,
  setAuthTokens as setApolloAuthTokens,
} from "../apollo/client";

const LEGACY_AUTH_TOKEN_KEY = "auth-token";
const LEGACY_REFRESH_TOKEN_KEY = "auth-refresh-token";

const isBrowser = () => typeof window !== "undefined";

export const saveAuthToken = (authToken, refreshToken) => {
  if (!isBrowser()) {
    return;
  }

  setApolloAuthTokens({ authToken, refreshToken });

  if (authToken) {
    window.localStorage.setItem(LEGACY_AUTH_TOKEN_KEY, authToken);
  }

  if (refreshToken) {
    window.localStorage.setItem(LEGACY_REFRESH_TOKEN_KEY, refreshToken);
  }
};

export const clearAuthTokens = () => {
  if (!isBrowser()) {
    return;
  }

  clearApolloAuthTokens();
  window.localStorage.removeItem(LEGACY_AUTH_TOKEN_KEY);
  window.localStorage.removeItem(LEGACY_REFRESH_TOKEN_KEY);
};

export const handleLogout = async ({ redirectTo = "/sign-in" } = {}) => {
  try {
    clearAuthTokens();

    try {
      await client.resetStore();
    } catch (resetError) {
      // console.error("[Auth] resetStore failed during logout, trying clearStore", resetError);
      await client.clearStore();
    }

    navigate(redirectTo);
    toast.success("Successfully logged out");
  } catch (error) {
    // console.error("Logout error:", error);
    toast.error("Failed to logout. Please try again.");
  }
};

